import { render } from "./HeroiconsOutlineCube.vue?vue&type=template&id=07e46786"
const script = {}

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCube.vue"]])

export default __exports__